import React, { useState, useEffect, useContext } from "react";
import { Box, Text, Layer, Image, Button, TextInput } from "grommet";
import { Search } from "grommet-icons";
import firebase from "firebase/app";

import algoliasearch from "algoliasearch/lite";
import UserContext from "../context/UserContext";

const client = algoliasearch("FPUF7P23Y7", "4096d8d6f649f05502ca9e678e4c677a");

const SearchStoreModal = ({ modalCallback, selectedCallback, refreshCallback }) => {
	const index = client.initIndex("stores");
	const { authUser } = useContext(UserContext);
	const [address, setAddress] = useState("");
	const [storesToClaim, setStoresToClaim] = useState([]);
	const [noResults, setNoResults] = useState(false);
	const [storeSelected, setStoreSelected] = useState(null);

	const getResults = async () => {
		if (address !== "") {
			setNoResults(false);
			index.search(address).then(({ hits }) => {
				console.log(hits);
				setStoresToClaim(hits);
				hits.length === 0 && setNoResults(true);
			});
		} else {
			alert("Introduce un término de busqueda");
		}
	};

	

	return (
		<Layer>
			<Box pad="medium" gap="medium" width="large">
				<Text>Escribe la direccion del establecimiento que estas buscando</Text>
				<Box direction="row" gap="small">
					<TextInput icon={<Search />} value={address} onChange={(ev) => setAddress(ev.target.value)} placeholder="Dirección o Nombre del comercio..." />
					<Button
						onClick={() => {
							getResults();
						}}
						style={{ color: "white", fontWeight: "600", textAlign: "center", paddingLeft: 15, paddingRight: 15, height: 45, borderRadius: 5, alignItems: "center", justifyContent: "center" }}
						primary
						color="brand">
						Buscar
					</Button>
				</Box>

				<Box overflow="scroll" height="350px" width="100%" background="#f3f3f3" round="small" pad="medium" gap="small">
					{noResults ? (
						<Box fill align="center" justify="center">
							<Text>No se han encontrado establecimientos</Text>
						</Box>
					) : (
						storesToClaim.map((store, i) => {
							return (
								<Box
									key={i}
									onClick={() => (storeSelected?.objectID === store.objectID ? setStoreSelected(null) : setStoreSelected(store))}
									round="small"
									background="white"
									border={{ color: "brand", size: storeSelected?.objectID === store.objectID ? "2px" : "0px" }}
									align="center"
									direction="row"
									flex="grow"
									gap="small">
									<Box width="56px" height="56px" margin="4px" overflow="hidden" round="7px">
										<Image
											fill
											fit="cover"
											src={
												store.images && store.images[0]
													? store.images[0]
													: "data:image/png;base64,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"
											}
										/>
									</Box>
									<Box gap="5px">
										<Text weight="bold">{store.name}</Text>
										<Text>{store.fullAddress}</Text>
									</Box>
								</Box>
							);
						})
					)}
				</Box>
				<Box direction="row" justify="between">
					<Button
						onClick={() => {
							modalCallback(false);
						}}
						style={{ color: "white", fontWeight: "600", textAlign: "center", paddingLeft: 15, paddingRight: 15, height: 35, borderRadius: 5, alignItems: "center", justifyContent: "center" }}
						primary
						color="gainsboro">
						Cancelar
					</Button>
					{storeSelected && (
						<Button
							onClick={() => {
								selectedCallback(storeSelected);
							}}
							style={{ color: "white", fontWeight: "600", textAlign: "center", paddingLeft: 15, paddingRight: 15, height: 35, borderRadius: 5, alignItems: "center", justifyContent: "center" }}
							primary
							color="brand">
							Seleccionar Establecimiento
						</Button>
					)}
				</Box>
			</Box>
		</Layer>
	);
};

export default SearchStoreModal;
